/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectTaskBudgetCostCommand } from '../../models/create-project-task-budget-cost-command';
import { CreateProjectTaskBudgetCostCommandResult } from '../../models/create-project-task-budget-cost-command-result';

export interface ApiTaskBudgetCostCreateTaskBudgetCostPost$Plain$Params {
      body?: CreateProjectTaskBudgetCostCommand
}

export function apiTaskBudgetCostCreateTaskBudgetCostPost$Plain(http: HttpClient, rootUrl: string, params?: ApiTaskBudgetCostCreateTaskBudgetCostPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectTaskBudgetCostCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskBudgetCostCreateTaskBudgetCostPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectTaskBudgetCostCommandResult>;
    })
  );
}

apiTaskBudgetCostCreateTaskBudgetCostPost$Plain.PATH = '/api/TaskBudgetCost/CreateTaskBudgetCost';
